"use strict";

import preload from "./modules/preload.js";
import hamburger from "./modules/hamburger.js";
import showStyles from "./modules/styles.js";
import showProducts from "./modules/products.js";
import showSmallMenu from "./modules/smallMenu.js";
import showTopMenuAndArrows from "./modules/showTopMenu.js";
import { stylesImg, stylesLink } from "./services/variables.js";
import cookies from "./modules/coockies.js";

window.addEventListener("DOMContentLoaded", () => {
	cookies();
	preload(".overlay", "body", "style");
	window.addEventListener("scroll", showTopMenuAndArrows);

	listener("click");
	listener("touchend");

	function listener(action) {
		window.addEventListener(action, (e) => {
			if (
				e.target.classList.contains("style__show") ||
				e.target.closest(".btn__styles")
			) {
				showStyles(
					e.target,
					".btn__styles",
					"styles__link",
					"styles__title",
					"style__show",
				);
			} else if (e.target.closest(".products")) {
				showProducts(
					"menu__full_white",
					"menu__forbigproduct",
					"show",
					"overflow_hidden",
				);
			} else if (e.target.closest(".menu__subtitle")) {
				showSmallMenu(e.target, "show", "height", "overflow_scroll");
			} else if (
				e.target.closest(".hamburger") ||
				e.target.classList.contains(".hamburger")
			) {
				hamburger(
					"menu__full_white",
					"menu__forbigproduct",
					"menu__big_show",
					"menu__list_hide",
					"menu__display_none",
					"overflow_scroll",
					"overflow_hidden",
					"show",
					"height",
				);
			}
		});
	}

	stylesLink.forEach((item, i) => {
		item.addEventListener("mouseover", () => {
			stylesImg[i].classList.add("show");
		});
		item.addEventListener("mouseout", () => {
			stylesImg[i].classList.remove("show");
		});
	});
});
